module.exports = __webpack_public_path__ + "img/sbs-chill.5b069b3e.png";